import React from 'react';
import { Row } from 'react-bootstrap';
import {
  buildWhereForDates,
  FormCol,
  FormFilterCard,
  FieldInput,
  FieldDateRanger,
  FieldSelectIsActive,
  TableEditButtons,
  FormCol3,
  FieldSelectYesNo,
} from 'motion-components';
import { useTranslation } from 'react-i18next';
import {
  FieldSelectCollector,
  FieldSelectMaterialGroup,
  FormFieldMultiMaterialDlg,
} from 'shared-pages';

import { isRebatteryLiion, isRebattery } from 'shared-pages/common/constants';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [{ plateNumber: likeObj }],
      };
    }
    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }
    if (values.collectorId && values.collectorId !== undefined) {
      where = { ...where, collectorId: values.collectorId };
    }
    if (values.isApproved !== undefined && values.isApproved !== null && values.isApproved !== '') {
      where = { ...where, isApproved: values.isApproved };
    }

    // if (values.collectorId) where = { ...where, collectorId: values.collectorId };
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false, isGridInForm }) => {
  //
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    isActive: initialValues?.isActive ?? null,
    collectorId: initialValues?.collectorId ?? undefined,
    isApproved: initialValues?.isApproved ?? null,
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση ( Αρ. Κυκλοφορίας )')}
          type="search"
          disable={disable}
        />
        {!isGridInForm && (
          <FieldSelectCollector as={FormCol} name="collectorId" label={t('Συλλέκτης')} />
        )}
        {(isRebattery || isRebatteryLiion) && (
          <FieldSelectYesNo label={t('Εγκεκριμένα Οχήματα')} disable={disable} name="isApproved" />
        )}
        <FieldSelectIsActive label={t('Ενεργές Εγγραφές')} disable={disable} />
      </Row>
    </FormFilterCard>
  );
};
